import $ from "./jquery-shim";


let defaultOptions = {
  selector: ".js-select-change",
  selectorBlock: ".js-product-block",
  inputAll: ".c-block-product-search__block-all input",
  detailedWrap: ".c-block-product-search__wrap-inner"
}

export default class searchControl {

  constructor(options) {
    this.options = $.extend(defaultOptions, options);
    this.init();
  }

  /**
   * 初期化
   */
  init() {
    this.targetEle = $(this.options.selector);
    this.targetBlock = $(this.options.selectorBlock);
    this.inputAll = $(this.options.selectorBlock).find(this.options.inputAll);
    this.detailedWrap = $(this.options.detailedWrap);
    this.delete();
    this.show(this.targetEle);
    // this.reset(this.inputAll);
    this.deleteDetail(this.targetEle);
    this.targetEle.change(() => {
      this.delete();
      this.show(this.targetEle);
      this.reset(this.inputAll);
      this.deleteDetail(this.targetEle);
    });
  }

  // selectのvalueを取得
  getValue(el) {
    let value;
    if ($(el).val()) {
      value = $(el).val();
    } else {
      value = 'js-product-block';
    }
    return value;
  }

  // 表示したい要素を取得
  targetSelector(val) {
    return $(`.${val}`);
  }

  // 一旦全て削除
  delete() {
    this.targetBlock.hide();
  }

  // this.targetSelectorで取得した要素を表示
  show(el) {
    this.detailedWrap.show();
    this.targetSelector(this.getValue(el)).show();
    this.targetBlock.find(".js-change-able").prop('disabled', false);
  }

  // 製品カテゴリーを切り替え時詳細条件をリセットする
  reset(el) {
    el.prop('checked', true);
  }

  // 詳細条件がなかった時ブロックごと非表示
  deleteDetail(el) {
    if (this.targetSelector(this.getValue(el)).length === 0) {
      this.detailedWrap.hide();
      this.targetBlock.find(".js-change-able").prop('disabled', true);
    }
  }
}

